export default __webpack_public_path__ + "static/media/userIcon.3af3b671.svg";